// extracted by mini-css-extract-plugin
export default {"textFeedback":"LatestCurrentFirmwareVersion_textFeedback__4fK2w","textButton":"LatestCurrentFirmwareVersion_textButton__Jl4Bb"};